import { Button } from '@eventbrite/eds-button';
import { Icon } from '@eventbrite/eds-icon';
import {
    ChevronDownChunky,
    ChevronUpChunky,
} from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent, ReactNode } from 'react';

const DEFAULT_COLLAPSED_LINK_TEXT = (
    <div>
        {gettext('Show Details')}
        <Icon type={<ChevronDownChunky />} size="small" />
    </div>
);

const DEFAULT_EXPANDED_LINK_TEXT = (
    <div>
        {gettext('Hide Details')}
        <Icon type={<ChevronUpChunky />} size="small" />
    </div>
);

interface ToggleButtonProps {
    collapsedLinkText?: ReactNode;
    expandedLinkText?: ReactNode;
    isExpanded: boolean;
    onClick: () => void;
    customClassNames?: string;
}

export const ToggleButton: FunctionComponent<ToggleButtonProps> = ({
    collapsedLinkText = DEFAULT_COLLAPSED_LINK_TEXT,
    customClassNames,
    expandedLinkText = DEFAULT_EXPANDED_LINK_TEXT,
    isExpanded,
    onClick,
}) => {
    const linkText = isExpanded ? expandedLinkText : collapsedLinkText;
    return (
        <Button
            style="anchor"
            onClick={onClick}
            data-spec="read-more-toggle"
            data-testid="read-more-toggle"
            __containerClassName={classNames(
                'eds-read-more__button',
                customClassNames,
            )}
        >
            {linkText}
        </Button>
    );
};
